// Module
var code = "<a class=\"md-accent md-hue-1 br-link-1\" ng-click=\"$event.stopPropagation();\" ng-disabled=\"!$ctrl.id\" ui-sref=\"contract.details.service({contractId: $ctrl.id, programId: $ctrl.programId})\"> {{$ctrl.name || $ctrl.id}} </a> ";
// Exports
export default code;